import { FolderLocation } from 'models/types';

const MutationKeys = {
    CANCEL_SEND: ['cancel-send'],
    COPY_GENERATOR_GENERATE: ['copy-generator-generate'],
    COPY_GENERATOR_MESSAGE_FEEDBACK: (messageId: number) => ['copy-generator-message-feedback', messageId],
    CREATE_CLICK_APPOINTMENT_VALUE_ASSUMPTION: ['create-click-appointment-value-assumption'],
    CREATE_AUDIENCE: ['create-audience'],
    CREATE_CAMPAIGN: ['create-campaign'],
    CLONE_CAMPAIGN: ['clone-campaign'],
    CREATE_DRAFT_CAMPAIGN: ['create-draft-campaign'],
    UPDATE_DRAFT_CAMPAIGN: ['update-draft-campaign'],
    CREATE_CONTENT_FOLDER: ['create-content-folder'],
    CREATE_DIRECT_MAIL: ['create-direct-mail'],
    CREATE_DISPLAY_CONDITION: ['create-display-condition'],
    UPDATE_DISPLAY_CONDITION: (conditionId: number) => ['update-display-condition', conditionId],
    ARCHIVE_DISPLAY_CONDITION: (conditionId: number) => ['archive-display-condition', conditionId],
    UNARCHIVE_DISPLAY_CONDITION: (conditionId: number) => ['unarchive-display-condition', conditionId],
    CREATE_LANDING_PAGE: ['create-landing-page'],
    CREATE_SEGMENT: ['create-segment'],
    CREATE_SEGMENT_FOLDER: ['create-segment-folder'],
    CREATE_SEND: ['create-send'],
    CREATE_SMS: ['create-sms'],
    CREATE_WHATSAPP_TEMPLATE: ['create-whatsapp-template'],
    CREATE_TEMPLATE: ['create-template'],
    CREATE_VOICE_CONTENT: ['create-voice-content'],
    DELETE_CAMPAIGN: ['delete-campaign'],
    DELETE_CONTENT_FOLDER: ['delete-content-folder'],
    DELETE_LANDING_PAGE: ['delete-landing-page'],
    DELETE_SEGMENT: ['delete-segment'],
    DELETE_SEGMENT_FOLDER: ['delete-segment-folder'],
    ARCHIVE_CAMPAIGN: ['archive-campaign'],
    UNARCHIVE_CAMPAIGN: ['unarchive-campaign'],
    ARCHIVE_SEGMENT: ['archive-segment'],
    UNARCHIVE_SEGMENT: ['unarchive-segment'],
    DELETE_TEMPLATE: ['delete-template'],
    ARCHIVE_CONTENT: ['archive-content'],
    UNARCHIVE_CONTENT: ['unarchive-content'],
    DELETE_SMS: ['delete-sms'],
    DELETE_WHATSAPP_TEMPLATE: ['delete-whatsapp-template'],
    DELETE_VOICE_CONTENT: ['delete-voice-content'],
    DECLARE_AB_TEST_WINNER: ['declare-ab-test-winner'],
    SCHEDULE_AB_TEST_WINNER: ['schedule-ab-test-winner'],
    GET_AB_TEST_INSIGHTS: ['get-ab-test-insights'],
    GET_AUDIENCE_COUNT: ['get-audience-count'],
    GET_APPOINTMENT_VALUE: ['get-appointment-value'],
    GET_SEGMENT_PREVIEW_COUNT: ['get-segment-preview-count'],
    MOVE_FOLDER: (folderLocation: FolderLocation) => [`move-${folderLocation}-folder`],
    PREVIEW_DIRECT_MAIL_PDF: ['preview-direct-mail-pdf'],
    RENAME_FOLDER: (folderLocation: FolderLocation) => [`rename-${folderLocation}-folder`],
    SEND_TEST_EMAIL: ['send-test-email'],
    SEND_TEST_SMS: ['send-test-sms'],
    UPDATE_CAMPAIGN: ['update-campaign'],
    UPDATE_CAMPAIGN_STATUS: ['update-campaign-status'],
    UPDATE_CAMPAIGN_EXIT_CRITERIA: (campaignId: string) => ['update-campaign-exit-criteria', campaignId],
    UPDATE_DIRECT_MAIL: ['update-direct-mail'],
    UPDATE_SEGMENT: (segmentId: number) => ['update-segment', segmentId],
    UPDATE_SEND: (sendId: string) => ['update-send', sendId],
    UPDATE_LANDING_PAGE: ['update-landing-page'],
    UPDATE_SMS: ['update-sms'],
    UPDATE_WHATSAPP_TEMPLATE: ['update-whatsapp-template'],
    UPDATE_TEMPLATE: ['update-template'],
    UPDATE_VOICE_CONTENT: ['update-voice-content'],
    UPDATE_CONTENT_STATUS: ['update-content-status'],
    UPLOAD_PDF: ['upload-pdf'],
    UNSUBSCRIBE: ['unsubscribe'],
    /** PUT /users/:userId/role — shared key for `useMutationStatus` (Users page snackbar). */
    ASSIGN_USER_ROLE: ['assign-user-role'],
    /** PATCH /users/:userId — update user display name */
    PATCH_USER_DISPLAY_NAME: (userId: string) => ['patch-user-display-name', userId],
    /** POST /users/bulk-assign-role */
    BULK_REASSIGN_USER_ROLE: ['bulk-reassign-user-role'],
    CREATE_ROLE: ['create-role'],
    UPDATE_ROLE: (roleId: number) => ['update-role', roleId],
    UPDATE_BRAND_PROFILE: ['update-brand-profile'],
    PARSE_MIGRATE_TEMPLATE: ['parse-migrate-template'],
    EXECUTE_MIGRATE_TEMPLATE: ['execute-migrate-template'],
    EXECUTE_INCONNECT_IMPORT: ['execute-inconnect-import'],
    SAVE_IMPORT_MAPPINGS: ['save-import-mappings'],
    CREATE_SAVED_ROW: ['create-saved-row'],
    UPDATE_SAVED_ROW: ['update-saved-row'],
    /** POST /saved-rows/template-row-link */
    LINK_SAVED_ROW_TEMPLATE: ['link-saved-row-template'],
    CREATE_GUARDRAIL: ['create-guardrail'],
    UPDATE_GUARDRAIL: ['update-guardrail'],
    DELETE_GUARDRAIL: ['delete-guardrail'],
};

export default MutationKeys;
